module.exports = __webpack_public_path__ + "img/pagination-dropdown-icon.3ffef22f.svg";